// extracted by mini-css-extract-plugin
module.exports = {"title":"list_title__Twk42","more":"list_more__LJQ6j","more-text":"list_more-text__f9O5B"};